import { Component, Inject, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { AssignWaveProtocolPopupComponent } from './assignwaveprotocol-popup/assignwaveprotocol-popup.component';
import { ImportProtocolsPopupComponent } from './importprotocols-popup/importprotocols-popup.component';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { OshWave } from '../../../../../interfaces/osh/oshWave';
import { OshWaveProtocolConfig } from '../../../../../interfaces/osh/oshWaveProtocolConfig';

@Component({
    selector: 'osh-waveprotocolconfig',
    templateUrl: './waveprotocolconfig.component.html',
    styleUrls: ['./waveprotocolconfig.component.less',
        '../oshadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class OshWaveProtocolConfigComponent implements OnChanges, OnDestroy {

    public dataSource = new MatTableDataSource<OshWaveProtocolConfig>();

    @Input() selectedWave: OshWave | undefined;
    columnsToDisplay = ['Checkbox', 'protocolCode', 'protocolName'];

    isRemoveProtocolAssignmentEnabled = false;
    removeProtocolList: number[] = []
    dialog: any;
    
    private readonly _onDestroy = new Subject<void>();
    private lastWaveId: number = -1;
    
    constructor(
        private readonly http: HttpClient
        , private readonly dialogForm: MatDialog
        , @Inject('BASE_URL') private readonly baseUrl: string
        , private readonly customDialog: CustomDialogService
        , public defaults: DefaultValuesService
        , private readonly toastrService: ToastrService) { }

    
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedWave'] && this.selectedWave?.id !== this.lastWaveId) {
            this.lastWaveId = this.selectedWave?.id ?? -1;
            this.reload();
        }
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    reload() {
        if (this.selectedWave && this.selectedWave?.id !== -1)
            Utils.httpGetOshWaveProtocolConfigurations(
                this.http,
                this.baseUrl,
                this.selectedWave.id,
                this,
                function (tthis: OshWaveProtocolConfigComponent, list: any) {
                    tthis.dataSource.data = list
                    tthis.removeProtocolList = [];
                    tthis.isRemoveProtocolAssignmentEnabled = false;
                },
                null
            )
    }

    controlAssignedItem(ischecked: boolean, row?: any) {
        if (row) {
            if (ischecked) {
                this.removeProtocolList.push(row.protocolId);
                return;
            }
            const index = this.removeProtocolList.indexOf(row.protocolId);
            if (index !== -1) {
                this.removeProtocolList.splice(index, 1);
            }
            return;
        }

        this.removeProtocolList = ischecked
            ? (this.dataSource.data ?? []).map((x: any) => x.protocolId)
            : [];
    }

    isAllSelected(): boolean {
        const total = this.dataSource.data?.length ?? 0;
        return total > 0 && this.removeProtocolList.length === total;
    }

    isPartiallySelected(): boolean {
        return this.removeProtocolList.length > 0 && !this.isAllSelected();
    }

    onCheckboxKeydown(event: KeyboardEvent, element: any) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const checkbox = event.target as HTMLInputElement;
            const newCheckedState = !checkbox.checked;
            this.controlAssignedItem(newCheckedState, element);
            checkbox.checked = newCheckedState;
        }
    }

    openAssignProtocolWave() {
        this.dialog = this.dialogForm.open(AssignWaveProtocolPopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            data: this.selectedWave
        })
        this.afterAssigningProtocols();
    }

    openImportProtocols() {
        this.dialog = this.dialogForm.open(ImportProtocolsPopupComponent, {
            panelClass: ['custom-mat-dialog_v2'],
            disableClose: true,
            data: this.selectedWave
        })

        this.afterAssigningProtocols();
    }

    private afterAssigningProtocols() {
        this.dialog.afterClosed().subscribe(() => {
            if (this.selectedWave?.id !== -1)
                Utils.httpGetOshWaveProtocolConfigurations(
                    this.http,
                    this.baseUrl,
                    this.selectedWave!.id,
                    this,
                    function (tthis: OshWaveProtocolConfigComponent, list: any) {
                        tthis.dataSource.data = list
                    },
                    null
                )
        })
    }
    
    confirmRemoveProtocols() {    
        this.customDialog.openConfirm({
            title: "Unassign Protocols",
            message: `Do you want to unassign all selected protocols?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed) {
                Utils.httpUnassignOshWaveProtocolConfigurations(
                    this.http
                    , this.baseUrl
                    , this.selectedWave?.id
                    , this.removeProtocolList
                    , this
                    , function (tthis: OshWaveProtocolConfigComponent, result: any) {
                        if (result) {
                            tthis.reload();
                            tthis.toastrService.success(`Protocols were unassigned successfully!`);
                        }
                        else
                            tthis.toastrService.error(`Protocols could not be unassigned. Please, contact with administrator`);
                    },
                    null
                );
            }
        });
    }


    enableRemoveAssignmentMode() {
        this.isRemoveProtocolAssignmentEnabled = !this.isRemoveProtocolAssignmentEnabled;
        if (this.isRemoveProtocolAssignmentEnabled)
            this.removeProtocolList = [];
    }
}

// using centralized interfaces

